import { render, staticRenderFns } from "./SaveCriteriaAsTemplate.vue?vue&type=template&id=7b136474&scoped=true"
import script from "./SaveCriteriaAsTemplate.vue?vue&type=script&lang=js"
export * from "./SaveCriteriaAsTemplate.vue?vue&type=script&lang=js"
import style0 from "./SaveCriteriaAsTemplate.vue?vue&type=style&index=0&id=7b136474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b136474",
  null
  
)

export default component.exports